<template>
  <div>
    <comment-form-modal :action="handleSubmitCommentForm" />

    <el-dropdown split-button type="success" @click="handleStatusChange({ status: 'approved' })" @command="handleOpenCommentModal" v-if="timesheet.status !== 'approved' && timesheet.status !== 'archived'">
      <i class="fa fa-check"></i> Approve
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="approved">Approve with comment</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown split-button type="danger" @click="handleStatusChange({ status: 'rejected' })" @command="handleOpenCommentModal" v-if="timesheet.status !== 'rejected' && timesheet.status !== 'archived'">
      <i class="fa fa-ban"></i> Reject
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="rejected">Reject with comment</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

<!--     <el-button @click="handleStatusChange({ status: 'archived' })" v-if="timesheet.status !== 'archived'">Archive</el-button>
    <el-button @click="handleStatusChange({ status: 'pending' })" v-if="timesheet.status === 'archived'">Unarchive</el-button>
 -->  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import commentConstants from '@/store/modules/comment/constants';
  import CommentFormModal from '@/components/comment/CommentFormModal';
  import { EventBus } from '@/components/event-bus';

  export default {
    name: 'TimesheetStatusButtons',
    components: {
      commentFormModal: CommentFormModal,
    },
    props: {
      timesheet: {
        type: Object,
        required: true,
      },
      onStatusChange: {
        type: Function,
      },
    },
    methods: {
      ...mapActions('entities/timesheets', ['changeStatus']),
      ...mapActions('entities/comments', ['openFormModal', 'closeFormModal']),

      handleStatusChange(data) {
        this.handleCloseCommentModal();

        this.changeStatus({ id: this.timesheet.id, data })
          .then((response) => {
            if (response.status) {
              if (this.onStatusChange) this.onStatusChange(response, data);
              EventBus.$emit('refresh-header');
              this.$message({ type: 'success', message: 'Status has been changed successfully.' });
              this.$router.push({ name: 'timesheets' });
            } else {
              this.$message({ type: 'error', message: response.error });
            }
          });
      },

      handleOpenCommentModal(command) {
        const buttonText = command === 'approved' ? 'Approve' : 'Reject';
        const label = command === 'approved' ? commentConstants.LABELS.timesheetApproved : commentConstants.LABELS.timesheetRejected;

        this.openFormModal({ id: this.timesheet.id, type: 'Timesheet', label, command, buttonText });
      },

      handleCloseCommentModal() {
        this.closeFormModal();
      },

      handleSubmitCommentForm(command, commentData) {
        this.handleStatusChange({ status: command, comments_attributes: commentData });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/timesheet/TimesheetStatusButtons.vue